import styled from 'styled-components';
import IconButton from 'components/mediabay-ui/components/IconButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #000;

  @media(min-width: 768px) {
    flex-direction: row;
    min-height: 400px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;

  & .video-js {
    font-size: 0.9em;
  }

  @media(min-width: 768px) {
    width: 60%;
    margin: 0 auto;
  }
`;

export const PlayButton = styled(IconButton)`
  z-index: 5;
  position: relative;
  border: 3px solid #0d63ff;
  border-radius: 50%;
  background: rgba(63, 81, 181, .4);
  padding: 20px;
  outline: 0;
  cursor: pointer;
  transition: all .4;

  &:hover {
    background: #0d63ff;
  }
`;

export const PlayerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  margin: 0 auto;
  padding: 10px 0;
`;

export const EpisodesContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-height: 500px;
  ${'' /* max-height: 400px; */}
  margin: 10px 0;
  overflow-y: auto;

  @media(min-width: 768px) {
    width: 300px;
    border-left: 1px solid #333;
  }

  @media(min-width: 1200px) {
    width: 400px;
  }

  select {
    width: 100%
    background: #000;
    border: 0;
    border-bottom: 2px solid #333;
    font-size: 17px;
    color: #fff;
    padding: 10px;
  }


  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-track {
      background: #1e1e1e;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #383b3b;
  }

  &::-webkit-scrollbar-thumb:hover {
      background: #565a5a;
  }
`;

export const EpisodeItem = styled.button`
  background: transparent;
  border: 0;
  width: 100%;
  font-size: ${props => (props.isActive ? '17px' : '16px')};
  color: ${props => (props.isActive ? '#fff' : '#aaa')};
  margin: 0;
  padding: 6px 30px;
  text-align: left;
  vertical-align: middle;
  cursor: pointer;

  &:hover {
    background: #111;
  }
`;
